export default {
    en: {
        id: 'diagram4b2-8',
        blocks: [
          {
            index: '1',
            task: 'S = CFOs often allow last year’s budget target to influence the setting of this year’s goal - an unconscious bias called anchoring',
            title: "S = "
          },
          {
            index: '2',
            task: 'C = Common attempts to overcome the anchor do not work well',
            title: "C = "
          },
          {
            index: '3',
            task: 'Q = What does work?',
            title: "Q = "
          }
        ],
        answers: [
          {
            index: '2',
            title: 'Difficult to solve'
          },
          {
            index: '3',
            title: 'What do?'
          },
          {
            index: '1',
            title: 'Have problem'
          },
        ],
        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
        correctAnswers: 3,
        note: `
          Were you annoyed by the length of this introduction?  How long should an introduction be?  How long should a man’s legs be? (Long enough to reach the ground).  This one is unnecessarily long and ponderous, partly because it has a double SCQ.  It first forces you to ask a question to which you do not yet want the answer (“What happened?”).  Then it makes you absorb the answer, before it presents a new Complication (Few solutions available).  You are then expected to ask “What works” to solve the problem, when in fact the problem hasn’t actually been stated.
          Is the subject of the article “budgeting” or “anchoring”.  It’s probably anchoring, so I would have said the structure should be:
          S = Anchoring is a well-known psychological bias
          C = Happens a lot in budgeting, causes bad problem (not stated in the current introduction)
          Q = How fix?
          A = Re-anchor.
        `
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b2/spottingSCQ/i18n/exercise8.js